import axios from "./axios";

const PaymentService = {
  getProviders: async (id) => {
    try {
      const response = await axios.get(`/payment-providers/public`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getProvidersPublic: async (id) => {
    try {
      const response = await axios.get(
        `/payment-providers/public`
      );
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  linkProviders: async (payload) => {
    try {
      const response = await axios.post(`/payment-providers/add`, payload);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  updateProviders: async (payload, id) => {
    try {
      const response = await axios.put(`/payment-providers/${id}`, payload);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  deleteProviders: async (id) => {
    try {
      const response = await axios.delete(`/payment-providers/${id}`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getTerminalAndCardReaders: async () => {
    try {
      const response = await axios.get(`/restaurant/terminals`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getTerminalAndCardReader: async (id) => {
    try {
      const response = await axios.get(`/payment-providers/${id}/terminal`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  createTerminalAndCardReader: async (payload,terminalCardReader) => {
    try {
      const response = await axios.post(`/payment-providers/${terminalCardReader[0]?.id}/terminal/pairing-code`, payload);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  updateTerminalAndCardReader: async (payload, id) => {
    try {
      const response = await axios.put(`/restaurant/terminals/${id}`, payload);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  deleteTerminalAndCardReader: async (id) => {
    try {
      const response = await axios.delete(`/restaurant/terminals/${id}`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
};

export default PaymentService;
